import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "c-bg--gray--pc c-common-footer-fixed" }
const _hoisted_2 = { class: "c-common-footer-fixed__inner" }
const _hoisted_3 = { class: "c-common-inner" }
const _hoisted_4 = { class: "p-the-h03" }
const _hoisted_5 = { class: "p-the-h03-detail" }
const _hoisted_6 = {
  class: "p-the-h03-detail__text",
  "data-translate-skip": ""
}
const _hoisted_7 = {
  class: "p-the-h03__text",
  "data-translate-skip": ""
}
const _hoisted_8 = { class: "p-the-h03" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "p-the-h03-detail" }
const _hoisted_11 = {
  class: "p-the-h03-detail__text",
  "data-translate-skip": ""
}
const _hoisted_12 = {
  class: "p-the-h03__text",
  "data-translate-skip": ""
}
const _hoisted_13 = {
  class: "p-the-h03__text",
  "data-translate-skip": ""
}
const _hoisted_14 = { class: "p-the-h03__text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheHeader = _resolveComponent("TheHeader")!
  const _component_TheBreadcrumb = _resolveComponent("TheBreadcrumb")!
  const _component_SmallText = _resolveComponent("SmallText")!
  const _component_IconInvestedRounded = _resolveComponent("IconInvestedRounded")!
  const _component_HContainer = _resolveComponent("HContainer")!
  const _component_HSpecColumnList = _resolveComponent("HSpecColumnList")!
  const _component_TextLabel = _resolveComponent("TextLabel")!
  const _component_TheHDetail = _resolveComponent("TheHDetail")!
  const _component_TheTemplateH = _resolveComponent("TheTemplateH")!
  const _component_IconUserImage = _resolveComponent("IconUserImage")!
  const _component_ButtonMain = _resolveComponent("ButtonMain")!
  const _component_FloatingGivePointButton = _resolveComponent("FloatingGivePointButton")!
  const _component_TheFooter = _resolveComponent("TheFooter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_TheHeader, { ref: "theHeader" }, null, 512),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_TheBreadcrumb),
        (_ctx.showTransacntionType())
          ? (_openBlock(), _createBlock(_component_TheTemplateH, {
              key: 0,
              heading: "ポイント詳細"
            }, {
              title: _withCtx(() => _cache[0] || (_cache[0] = [
                _createTextVNode("付与基準達成", -1)
              ])),
              "header-label": _withCtx(() => [
                _createVNode(_component_SmallText, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.investedId.label) + " " + _toDisplayString(_ctx.investedId.id), 1)
                  ]),
                  _: 1
                })
              ]),
              contents: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_TheHDetail, {
                    image: true,
                    "rounded-image": true,
                    "usage-point": _ctx.usagePoint,
                    "max-width": false
                  }, _createSlots({
                    image: _withCtx(() => [
                      _createVNode(_component_IconInvestedRounded, {
                        "icon-size": _ctx.iconSize,
                        "bg-color": _ctx.colorCode,
                        "icon-color": "#ffffff",
                        type: _ctx.investedDetails.image_type
                      }, null, 8, ["icon-size", "bg-color", "type"])
                    ]),
                    header: _withCtx(() => [
                      _createElementVNode("div", _hoisted_5, [
                        _createVNode(_component_SmallText, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.investedDetails.investment_criteria_id.label) + " " + _toDisplayString(_ctx.investedDetails.investment_criteria_id.id), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_HContainer, { "margin-size": "xs" }, {
                          content: _withCtx(() => [
                            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.investedDetails.invested_name), 1)
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    body: _withCtx(() => [
                      _createVNode(_component_HContainer, null, {
                        content: _withCtx(() => [
                          _createVNode(_component_SmallText, null, {
                            default: _withCtx(() => _cache[1] || (_cache[1] = [
                              _createTextVNode("摘要", -1)
                            ])),
                            _: 1,
                            __: [1]
                          }),
                          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.investedDetails.description), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_HContainer, null, {
                        content: _withCtx(() => [
                          _createVNode(_component_HSpecColumnList, {
                            "list-item": _ctx.columnList,
                            "column-size": "m"
                          }, null, 8, ["list-item"])
                        ]),
                        _: 1
                      })
                    ]),
                    label: _withCtx(() => [
                      (_ctx.point.label)
                        ? (_openBlock(), _createBlock(_component_TextLabel, {
                            key: 0,
                            color: { border: '#9e9e9e', content: '#ffffff' },
                            reverse: true
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.point.label), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, [
                    (_ctx.point.expiration)
                      ? {
                          name: "point",
                          fn: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.point.expiration, ({ label, date }, key) => {
                              return (_openBlock(), _createBlock(_component_SmallText, { key: key }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(label) + " " + _toDisplayString(date == "Invalid Date" ? "--" : date), 1)
                                ]),
                                _: 2
                              }, 1024))
                            }), 128))
                          ]),
                          key: "0"
                        }
                      : undefined
                  ]), 1032, ["usage-point"])
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.transaction_type === 50)
          ? (_openBlock(), _createBlock(_component_TheTemplateH, {
              key: 1,
              heading: "ポイント詳細"
            }, {
              title: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.titleThanksgiving), 1)
              ]),
              "header-label": _withCtx(() => [
                (_ctx.approvalEnabled)
                  ? (_openBlock(), _createBlock(_component_TextLabel, {
                      key: 0,
                      color: { border: '#616161', content: '#ffffff' },
                      reverse: false
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.approvedLabel), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              contents: _withCtx(() => [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_TheHDetail, {
                    image: true,
                    "usage-point": _ctx.givePoint
                  }, _createSlots({
                    image: _withCtx(() => [
                      _createVNode(_component_IconUserImage, { size: _ctx.userImageSize }, {
                        default: _withCtx(() => [
                          _createElementVNode("img", {
                            src: _ctx.image,
                            alt: ""
                          }, null, 8, _hoisted_9)
                        ]),
                        _: 1
                      }, 8, ["size"])
                    ]),
                    header: _withCtx(() => [
                      _createElementVNode("div", _hoisted_10, [
                        _createVNode(_component_SmallText, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.giveData.give_details.give_id.label) + "  " + _toDisplayString(_ctx.giveData.give_details.give_id.id), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_HContainer, { "margin-size": "xs" }, {
                          content: _withCtx(() => [
                            _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.giveDetails.give_to), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_HContainer, { "margin-size": "xs" }, {
                          content: _withCtx(() => [
                            _createVNode(_component_SmallText, { "data-translate-skip": "" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.giveDetails.group_name), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_HContainer, { "margin-size": "xs" }, {
                          content: _withCtx(() => [
                            _createVNode(_component_SmallText, null, {
                              default: _withCtx(() => [
                                _createTextVNode("ID：" + _toDisplayString(_ctx.giveDetails.group_code), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    body: _withCtx(() => [
                      _createVNode(_component_HContainer, { "margin-size": "m" }, {
                        content: _withCtx(() => [
                          _createVNode(_component_SmallText, null, {
                            default: _withCtx(() => _cache[2] || (_cache[2] = [
                              _createTextVNode("タイトル", -1)
                            ])),
                            _: 1,
                            __: [2]
                          }),
                          _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.message.title), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_HContainer, { "margin-size": "m" }, {
                        content: _withCtx(() => [
                          _createVNode(_component_SmallText, null, {
                            default: _withCtx(() => _cache[3] || (_cache[3] = [
                              _createTextVNode("メッセージ", -1)
                            ])),
                            _: 1,
                            __: [3]
                          }),
                          _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.message.text), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_HContainer, { "margin-size": "m" }, _createSlots({ _: 2 }, [
                        (_ctx.messsageThreadEnabled == 1)
                          ? {
                              name: "content",
                              fn: _withCtx(() => [
                                _createVNode(_component_ButtonMain, {
                                  tag: "a",
                                  kind: "secondary",
                                  reverse: true,
                                  href: _ctx.message.url
                                }, {
                                  default: _withCtx(() => _cache[4] || (_cache[4] = [
                                    _createTextVNode(" メッセージスレッドを見る ", -1)
                                  ])),
                                  _: 1,
                                  __: [4]
                                }, 8, ["href"])
                              ]),
                              key: "0"
                            }
                          : undefined
                      ]), 1024),
                      _createVNode(_component_HContainer, { "margin-size": "l" }, {
                        content: _withCtx(() => [
                          _createVNode(_component_SmallText, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.giveDetails.dateLabel), 1)
                            ]),
                            _: 1
                          }),
                          _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.giveDetails.date), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, [
                    (_ctx.pointThanksgiving.expiration)
                      ? {
                          name: "point",
                          fn: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pointThanksgiving.expiration, ({ label, date }, key) => {
                              return (_openBlock(), _createBlock(_component_SmallText, { key: key }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(label) + " " + _toDisplayString(date), 1)
                                ]),
                                _: 2
                              }, 1024))
                            }), 128))
                          ]),
                          key: "0"
                        }
                      : undefined
                  ]), 1032, ["usage-point"])
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_FloatingGivePointButton),
    _createVNode(_component_TheFooter)
  ]))
}